module.exports = __webpack_public_path__ + "static/W-8BEN-E-518e7fd2cac6dec4cadc043f35e5712b.pdf";